import { nsSubscription } from '@/app/i18n/namespaces';

const SUBSCRIPTION_STATUS = {
    TO_BE_ACTIVATED: { name: 'TO_BE_ACTIVATED', entity: 'status.TO_BE_ACTIVATED', namespace: nsSubscription, variant: 'orange' },
    ACTIVATED: { name: 'ACTIVATED', entity: 'status.ACTIVATED', namespace: nsSubscription, variant: 'green' },
    TERMINATED: { name: 'TERMINATED', entity: 'status.TERMINATED', namespace: nsSubscription, variant: 'red' },
    IN_STOCK: { name: 'IN_STOCK', entity: 'status.IN_STOCK', namespace: nsSubscription, variant: 'blue' }
};

const SUBSCRIPTION_STATUS_SELECT_FILTERS = { ...SUBSCRIPTION_STATUS };
delete SUBSCRIPTION_STATUS_SELECT_FILTERS.IN_STOCK;

export default SUBSCRIPTION_STATUS;